import createStyledEnhancer from "../helpers/createStyledEnhancer";
import { composeEnhancers } from "../helpers";
export var width = createStyledEnhancer({
  name: "width"
});
export var minWidth = createStyledEnhancer({
  name: "minWidth"
});
export var maxWidth = createStyledEnhancer({
  name: "maxWidth"
});
export var height = createStyledEnhancer({
  name: "height"
});
export var minHeight = createStyledEnhancer({
  name: "minHeight"
});
export var maxHeight = createStyledEnhancer({
  name: "maxHeight"
});
export var sizes = composeEnhancers(width, height, minWidth, maxWidth, minHeight, maxHeight);
/** Пропсы, которые стайлед будет пытаться преобразовать в атрибуты. Нужны для фильтрации */

export var sizePropsNoForward = ["width", "height"];